import { useState, useEffect } from 'react';
import { useNavigate, Outlet, Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, LogOut, Shield, Heart, ChevronRight, ShieldCheck, Flag, CreditCard } from 'lucide-react';
import { Button } from '../../components/ui/button';

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    const stored = localStorage.getItem('admin_data');
    if (!token || !stored) { navigate('/admin/login'); return; }
    try { setAdmin(JSON.parse(stored)); } catch { navigate('/admin/login'); }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_data');
    navigate('/admin/login');
  };

  const navItems = [
    { to: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/admin/users', icon: Users, label: 'User Management' },
    { to: '/admin/kyc', icon: ShieldCheck, label: 'KYC Queue' },
    { to: '/admin/moderation', icon: Flag, label: 'Moderation' },
    { to: '/admin/revenue', icon: CreditCard, label: 'Revenue' },
  ];

  const isActive = (path) => location.pathname === path;

  if (!admin) return null;

  return (
    <div className="min-h-screen bg-[#F9F5F0] flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-64 bg-[#2D2424] text-white flex flex-col fixed h-screen z-40">
        <div className="p-5 border-b border-white/10">
          <Link to="/admin" className="flex items-center gap-2">
            <Shield className="w-6 h-6 text-[#F2A900]" />
            <span className="text-lg font-bold">Vivah<span className="text-[#D9381E]">Rang</span></span>
          </Link>
          <p className="text-xs text-white/40 mt-1">Admin Panel</p>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`admin-nav-${item.label.toLowerCase().replace(' ', '-')}`}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive(item.to) ? 'bg-[#D9381E] text-white' : 'text-white/70 hover:bg-white/10 hover:text-white'
              }`}
            >
              <item.icon className="w-4 h-4" />
              {item.label}
              {isActive(item.to) && <ChevronRight className="w-3 h-3 ml-auto" />}
            </Link>
          ))}
        </nav>

        <div className="p-3 border-t border-white/10">
          <div className="px-3 py-2 mb-2">
            <p className="text-sm font-medium text-white truncate">{admin.name}</p>
            <p className="text-xs text-white/40 truncate">{admin.email}</p>
          </div>
          <Button onClick={handleLogout} variant="ghost" className="w-full justify-start text-red-400 hover:text-red-300 hover:bg-red-500/10" data-testid="admin-logout-btn">
            <LogOut className="w-4 h-4 mr-2" /> Logout
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 ml-64 p-6 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
